import { SyncProcessLogSeverityEnum } from '../Enums/SyncProcessLogSeverityEnum';
import { SyncProcessLogSubjectTypeEnum } from '../Enums/SyncProcessLogSubjectTypeEnum';

/**
 * Filtros del listado de logs de un proceso de sincronización.
 *
 * Los resuelve el servidor (`.../consumptions/sync/{id}/logs`), no la pantalla:
 * con el listado paginado, filtrar en el cliente sólo alcanzaría a la página
 * que está cargada y tanto los totales como el recorrido de páginas quedarían
 * mal.
 *
 * `severity` y `subjectType` admiten un solo valor porque así los expone la
 * API; `undefined` significa "sin filtrar".
 */
export interface ISyncProcessLogsFilters {
    severity?: SyncProcessLogSeverityEnum;
    subjectType?: SyncProcessLogSubjectTypeEnum;
    /** Número de paciente en el protocolo (contiene). */
    patientNumber?: string;
    /** Busca en mensaje, nombre del sujeto y sugerencia (contiene). */
    searchText?: string;
}

export const EmptySyncProcessLogsFilters: ISyncProcessLogsFilters = {
    severity: undefined,
    subjectType: undefined,
    patientNumber: undefined,
    searchText: undefined,
};

/** Si hay algún filtro activo, para poder ofrecer "limpiar" sólo cuando sirve. */
export const hasActiveSyncProcessLogsFilters = (filters: ISyncProcessLogsFilters): boolean =>
    filters.severity !== undefined
    || filters.subjectType !== undefined
    || !!filters.patientNumber?.trim()
    || !!filters.searchText?.trim();
